<template>
    <div>
        {{ $t('block_confirmation.please_type_block') }}
        <div class="form-group">
            <input type="text" class="form-control" id="typed" :placeholder="$t('block_confirmation.type_block_here')"  v-model="typed">
        </div>
        <button class="btn btn-danger" :disabled="!deleteButtonEnabled" :class="{'disabled': !deleteButtonEnabled}" @click="$emit('clicked', true)">
            {{ $t('actions.block') }}
        </button>
    </div>
</template>

<script>
export default {
    name: "BlockConfirmation",
    data: () => ({
        typed: ''
    }),
    computed: {
        deleteButtonEnabled() {
            return this.typed === 'BLOCK';
        }
    }
}
</script>

<style scoped>

</style>
